import { registerLazyNotificationRenderer } from "@/entities/notification"

registerLazyNotificationRenderer(
	"personality-notification-first",
	() => import("../ui/personality-popup"),
)

registerLazyNotificationRenderer(
	"personality-notification-update",
	() => import("../ui/personality-popup"),
)
